import { Icon, ImgPh } from "../liquid/LiquidPrimitives";

interface ImageCarouselProps {
  images: string[];
  productName: string;
  productStock: number;
  onImageClick: () => void;
  selectedImage: number;
  onImageSelect: (index: number) => void;
  onNextImage: () => void;
  onPrevImage: () => void;
}

export default function ImageCarousel({
  images,
  productName,
  productStock,
  onImageClick,
  selectedImage,
  onImageSelect,
  onNextImage,
  onPrevImage,
}: ImageCarouselProps) {
  const safeImages = images.length > 0 ? images : [""];
  const activeImage = safeImages[selectedImage] || safeImages[0];

  return (
    <div style={{ display: "grid", gridTemplateColumns: "84px 1fr", gap: 16, height: 720 }}>
      <div className="no-scroll-bar" style={{ display: "flex", flexDirection: "column", gap: 10, overflowY: "auto" }}>
        {safeImages.map((image, index) => (
          <button
            key={`${image}-${index}`}
            type="button"
            onClick={() => onImageSelect(index)}
            style={{
              aspectRatio: "1/1",
              borderRadius: 16,
              border: selectedImage === index ? "2px solid var(--ink-900)" : "2px solid transparent",
              padding: 2,
              background: "transparent",
              cursor: "pointer",
              outline: "none",
            }}
          >
            {image ? (
              <img
                src={image}
                alt={`${productName} thumbnail ${index + 1}`}
                style={{ width: "100%", height: "100%", borderRadius: 12, objectFit: "cover" }}
              />
            ) : (
              <div style={{ width: "100%", height: "100%", borderRadius: 12, background: "linear-gradient(145deg, #F2E0BC, #C2965E)" }} />
            )}
          </button>
        ))}
        <button type="button" className="pill" style={{ padding: 10, marginTop: "auto", justifyContent: "center" }}>
          <Icon.plus />
        </button>
      </div>

      <div
        style={{
          position: "relative",
          borderRadius: 32,
          overflow: "hidden",
          background: "linear-gradient(160deg, #F4E8D2, #D4B68A)",
          boxShadow: "0 24px 60px -20px rgba(60,40,20,0.25)",
          cursor: "zoom-in",
        }}
        onClick={onImageClick}
      >
        {activeImage ? (
          <img
            src={activeImage}
            alt={`${productName} ${selectedImage + 1}`}
            style={{ width: "100%", height: "100%", objectFit: "contain", background: "rgba(255,250,240,0.32)" }}
          />
        ) : (
          <ImgPh
            label={productName}
            ratio="auto"
            style={{ height: "100%", borderRadius: 0, background: "linear-gradient(160deg, #F4E8D2 0%, #E0BD80 60%, #C49460 100%)" }}
          />
        )}

        <div className="lg" style={{ position: "absolute", top: 20, left: 20, padding: "8px 14px", borderRadius: 999, fontSize: 12, fontWeight: 500 }}>
          <span className="mono">{selectedImage + 1} / {safeImages.length}</span>
        </div>

        {productStock <= 0 && (
          <div className="lg-dark" style={{ position: "absolute", top: 20, left: "50%", transform: "translateX(-50%)", padding: "8px 14px", borderRadius: 999, fontSize: 12, fontWeight: 600 }}>
            Sin stock
          </div>
        )}

        <div className="lg" style={{ position: "absolute", top: 20, right: 20, padding: "8px 14px", borderRadius: 999, fontSize: 12, fontWeight: 500, display: "flex", alignItems: "center", gap: 6 }}>
          <Icon.search />
          Zoom
        </div>

        <button
          type="button"
          className="pill"
          style={{ position: "absolute", bottom: 20, right: 20, padding: 14 }}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
          }}
        >
          <Icon.heart />
        </button>
        <button
          type="button"
          className="pill"
          style={{ position: "absolute", left: 20, top: "50%", transform: "translateY(-50%)", padding: 14 }}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onPrevImage();
          }}
        >
          <Icon.arrowLeft />
        </button>
        <button
          type="button"
          className="pill"
          style={{ position: "absolute", right: 20, top: "50%", transform: "translateY(-50%)", padding: 14 }}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onNextImage();
          }}
        >
          <Icon.arrowRight />
        </button>
      </div>
    </div>
  );
}
